"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppUrlsService = /** @class */ (function () {
    function AppUrlsService() {
    }
    AppUrlsService.prototype.app = function () {
        return "/";
    };
    AppUrlsService.prototype.notificationPanel = function () {
        return "/notification-center";
    };
    AppUrlsService.prototype.notificationCenter = function () {
        return "/notification-center";
    };
    AppUrlsService.prototype.notificationSettings = function () {
        return "/notification-settings";
    };
    return AppUrlsService;
}());
exports.default = new AppUrlsService();
